import { type ReactElement } from "react";

import { AppLoadingPage, NotFoundPage } from "../lib";
import { AvailabilityCriteriaPage } from "./AvailabilityCriteriaPage";
import { DeprecatedWorkerAvailabilityPage } from "./deprecated/DeprecatedPage";
import {
  useWorkerAvailabilityVersion,
  WorkerAvailabilityVersion,
} from "./hooks/useWorkerAvailabilityVersion";

export function WorkerAvailabilityPage(): ReactElement {
  const workerAvailabilityRolloutVersion = useWorkerAvailabilityVersion();

  if (workerAvailabilityRolloutVersion === WorkerAvailabilityVersion.LOADING) {
    return <AppLoadingPage />;
  }

  if (workerAvailabilityRolloutVersion === WorkerAvailabilityVersion.V1) {
    return <DeprecatedWorkerAvailabilityPage />;
  }

  if (workerAvailabilityRolloutVersion === WorkerAvailabilityVersion.V2) {
    return <AvailabilityCriteriaPage />;
  }

  return <NotFoundPage />;
}
